import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import styles from './SwitchImgBtn.module.css';

const SwitchImgBtn = ({ rotation, display }) => {
  return (
    <div className={styles.btn}>
      <ArrowBackIosRoundedIcon
        style={{
          fontSize: '2rem',
          color: '#373737',
          transform: `rotate(${rotation})`,
          display,
        }}
      />
    </div>
  );
};

export default SwitchImgBtn;
